module.exports = __webpack_public_path__ + "assets/fa-regular-400.db78b9359171f24936b16d84f63af378.ttf";